import "react-tooltip/dist/react-tooltip.css";
import { ReactSVG } from "react-svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import NewToolTip from "../../common/New-ToolTip";
import { Tab, Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotePadModal from "../../common/note-pad/NotePadModal";
import ConfirmationModalNew from "../../common/ConfirmationModalNew";
import ChartUpdatesDialog from "../create/ChartUpdatesDialog";
import {
  deleteClinicalService,
  deleteMedicationReview,
  fetchClinicalServices,
} from "../../../redux/modules/clinical-services/actions";
import { ClinicalServiceTypes } from "../text/data";
import axios from "axios";

const PatientQuickActions = ({
  hasSavedNotes,
  openNotePad,
  onToggleNotePad,
  rxVigilanceAuthUrl,
  rxVigilanceBaseUrl,
}) => {
  const fetchVigilanceToken = async () => {
    const tokenResponse = await axios.post(
      `${rxVigilanceAuthUrl}/token`,
      new URLSearchParams({
        client_id: import.meta.env.VITE_APP_VIGILANCE_ID,
        client_secret: import.meta.env.VITE_APP_VIGILANCE_SECRET,
        user_id: "REEL01",
        grant_type: "client_credentials",
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    return tokenResponse.data.access_token;
  };

  const openRxVigilanceForm = (token, actionUrl) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = actionUrl;
    form.target = "_blank";

    const tokenInput = document.createElement("input");
    tokenInput.type = "hidden";
    tokenInput.name = "token";
    tokenInput.value = token;

    form.appendChild(tokenInput);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const handleRxVigilanceClick = async () => {
    try {
      const token = await fetchVigilanceToken();
      openRxVigilanceForm(token, `${rxVigilanceBaseUrl}/module/accueil/#/en`);
    } catch (error) {
      console.error("Failed to fetch access token:", error);
    }
  };

  const handleCalculusClick = async () => {
    try {
      const token = await fetchVigilanceToken();
      openRxVigilanceForm(token, `${rxVigilanceBaseUrl}/module/indexes/#/en/calculs`);
    } catch (error) {
      console.error("Failed to fetch access token:", error);
    }
  };

  const handleIndicationsClick = async () => {
    try {
      const token = await fetchVigilanceToken();
      openRxVigilanceForm(
        token,
        `${rxVigilanceBaseUrl}/module/indications/therapeuticobjectives-ndx.html?langue=en&serviceItem=diag_imm-`
      );
    } catch (error) {
      console.error("Failed to fetch access token:", error);
    }
  };

  const handleCouvertureClick = async () => {
    try {
      const token = await fetchVigilanceToken();
      const form = document.createElement("form");
      form.method = "POST";
      form.action = `${rxVigilanceBaseUrl}/module/couverture/couverture-ndx.html`;
      form.target = "_blank";

      const tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "token";
      tokenInput.value = token;

      const intrant = {
        query: { service: { id: "informationAndCoverage" } },
        profile: { patient: {} },
        viewerConfig: { language: "en" },
      };

      const intrantInput = document.createElement("input");
      intrantInput.type = "hidden";
      intrantInput.name = "intrant";
      intrantInput.value = JSON.stringify(intrant);

      form.appendChild(tokenInput);
      form.appendChild(intrantInput);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (error) {
      console.error("Failed to fetch access token:", error);
    }
  };

  return (
    <div className="flex items-center gap-4 -mt-2 pb-1">
      <button
        data-tooltip-id="aiTooltip"
        className="relative p-1 flex items-center justify-center rounded-[8px] bg-gray-10 hover:bg-gray-50 w-[60px] h-[44px]"
      >
        <img
          src="/icons/ai-icon.svg"
          alt="AI"
          className="cursor-pointer"
          style={{ width: 34, height: 34, objectFit: "contain" }}
        />
        <NewToolTip
          id={"aiTooltip"}
          render={() => (
            <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
              AI Insights Coming Soon
            </div>
          )}
        />
      </button>

      <img
        className="pr-1"
        src="/icons/logos/medSask-icon.png"
        alt="medSask"
        data-tooltip-id="medsasktip"
        style={{ cursor: "pointer", width: 80 }}
      />
      <NewToolTip
        id={"medsasktip"}
        render={() => (
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
            Coming Soon
          </div>
        )}
      />

      <button
        data-tooltip-id="vigilance"
        className="relative p-1 flex items-center justify-center rounded-[8px] bg-gray-10 hover:bg-gray-50 w-[60px] h-[44px]"
        onClick={handleRxVigilanceClick}
      >
        <img
          src="/icons/rx-vigilance-icon.svg"
          alt="Rx Vigilance"
          className="cursor-pointer"
          style={{ width: 34, height: 34, objectFit: "contain" }}
        />
      </button>
      <NewToolTip
        id={"vigilance"}
        render={() => (
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
            RxVigilance
          </div>
        )}
      />

      <button
        data-tooltip-id="clinicalCalcTooltip"
        className="relative p-1 flex items-center justify-center rounded-[8px] bg-gray-10 hover:bg-gray-50 w-[60px] h-[44px]"
        onClick={handleCalculusClick}
      >
        <img
          src="/icons/calcnew.svg"
          alt="Clinical Calculators"
          className="cursor-pointer"
          style={{ width: 34, height: 34, objectFit: "contain" }}
        />
      </button>
      <NewToolTip
        id={"clinicalCalcTooltip"}
        render={() => (
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
            <div>Clinical Calculators</div>
            <div style={{ fontStyle: "italic", fontSize: "13px" }}>By Vigilance Santé</div>
          </div>
        )}
      />

      <button
        data-tooltip-id="indicationsTooltip"
        className="relative p-1 flex items-center justify-center rounded-[8px] bg-gray-10 hover:bg-gray-50 w-[60px] h-[44px]"
        onClick={handleIndicationsClick}
      >
        <img
          src="/icons/info-vaccine.svg"
          alt="Indications"
          className="cursor-pointer"
          style={{ width: 34, height: 34, objectFit: "contain" }}
        />
      </button>
      <NewToolTip
        id={"indicationsTooltip"}
        render={() => (
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
            <div>Immunization</div>
            <div style={{ fontStyle: "italic", fontSize: "13px" }}>By Vigilance Santé</div>
          </div>
        )}
      />

      <button
        data-tooltip-id="couvertureTooltip"
        className="relative p-1 flex items-center justify-center rounded-[8px] bg-gray-10 hover:bg-gray-50 w-[60px] h-[44px]"
        onClick={handleCouvertureClick}
      >
        <img
          src="/icons/info-coverage.svg"
          alt="Couverture"
          className="cursor-pointer"
          style={{ width: 34, height: 34, objectFit: "contain" }}
        />
      </button>
      <NewToolTip
        id={"couvertureTooltip"}
        render={() => (
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
            <div>Information and Coverage</div>
            <div style={{ fontStyle: "italic", fontSize: "13px" }}>By Vigilance Santé</div>
          </div>
        )}
      />

      <button
        data-tooltip-id={"sNotes"}
        className={`relative p-1 w-[60px] h-[44px] flex items-center justify-center rounded-[8px] overflow-visible ${
          openNotePad ? "bg-teal-25" : "bg-gray-10 hover:bg-gray-50"
        }`}
        onClick={onToggleNotePad}
      >
        <ReactSVG
          src={"/icons/stickynote.svg"}
          className={`filter transition-all scale-[100%]`}
          style={{ width: 34, height: 34 }}
        />
        {hasSavedNotes && (
          <span className="absolute bottom-1 right-1 w-3 h-3 bg-REELTeal rounded-full border-2 border-white z-10 shadow-md"></span>
        )}
      </button>
      <NewToolTip
        id={"sNotes"}
        render={() => (
          <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2 text-center">
            <div>Notepad</div>
          </div>
        )}
      />
    </div>
  );
};

const PatientLayoutMain = ({ children }) => {
  const dispatch = useDispatch();
  const { id, serviceId } = useParams();
  const { clinicalServicesSmall, clinicalServiceName } = useSelector(
    (state) => state.clinicalService
  );
  const { minorAilments, medicationReviews } = clinicalServicesSmall;

  const vigilanceEnv = import.meta.env.VITE_VIGILANCE_ENV || "int";
  const rxVigilanceBaseUrl = `https://rx.${vigilanceEnv}.vigilance.ca`;
  const rxVigilanceAuthUrl = `https://rxauth.${vigilanceEnv}.vigilance.ca`;
  
  const notepad = useSelector((state) => state.patients?.notepad);
  const formsNotepad = useSelector((state) => state.patients?.formsNotepad);
  const [hasSavedNotes, setHasSavedNotes] = useState(false);
  
  useEffect(() => {
    const hasNotes = (notepad?.some(note => note.keepNote) || formsNotepad?.some(note => note.keepNote));
    setHasSavedNotes(hasNotes);
  }, [notepad, formsNotepad]);
  
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(null);
  const [openNotePad, setOpenNotePad] = useState(false);
  const [openPinItem, setOpenPinItem] = useState(-1);
  const [openSaveService, setOpenSaveService] = useState(false);
  const [openDeleteService, setOpenDeleteService] = useState(false);
  const [openSaveServiceForMedical, setOpenSaveServiceForMedical] =
    useState(false);
  const [openDeleteServiceForMedical, setOpenDeleteServiceForMedical] =
    useState(false);
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const params = useParams();
  const [iframeVisible, setIframeVisible] = useState(false);
  const [openExitServiceDialog, setOpenExitServiceDialog] = useState(false);
  const [navigationItem, setNavigationItem] = useState(null);

  const tabs = [
    {
      name: "Patient Chart",
      icon: `/icons/chart-new.svg`,
      iconInactive: "/icons/chart-new-inactive.svg",
      href: `/patient/${id}/`,
    },
    {
      name: "Clinical Services",
      icon: `/icons/clinical-services.svg`,
      iconInactive: "/icons/clinical-services-inactive.svg",
      href: `/patient/${id}/clinical-services/`,
    },
    {
      name: "Education",
      icon: `/icons/education.svg`,
      iconInactive: "/icons/education-inactive.svg",
      href: `/patient/${id}/education/`,
    },
  ];

  const handleToggleNotePad = () => {
    setOpenNotePad((prev) => !prev);
  };

  const CouvertureIcon = () => {
    const handleClick = async () => {
      try {
        const tokenResponse = await axios.post(
          `${rxVigilanceAuthUrl}/token`,
          new URLSearchParams({
            client_id: import.meta.env.VITE_APP_VIGILANCE_ID,
            client_secret: import.meta.env.VITE_APP_VIGILANCE_SECRET,
            user_id: "REEL01",
            grant_type: "client_credentials",
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        const token = tokenResponse.data.access_token;
        openCouvertureForm(token);
      } catch (error) {
        console.error("Failed to fetch access token:", error);
      }
    };

    const openCouvertureForm = (token) => {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = `${rxVigilanceBaseUrl}/module/couverture/couverture-ndx.html`;
      form.target = "_blank";

      const tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "token";
      tokenInput.value = token;

      const intrant = {
        query: {
          service: {
            id: "informationAndCoverage",
          },
        },
        profile: {
          patient: {},
        },
        viewerConfig: {
          language: "en",
        },
      };

      const intrantInput = document.createElement("input");
      intrantInput.type = "hidden";
      intrantInput.name = "intrant";
      intrantInput.value = JSON.stringify(intrant);

      form.appendChild(tokenInput);
      form.appendChild(intrantInput);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    };

    return (
      <button
        data-tooltip-id="couvertureTooltip"
        className="relative p-1 flex items-center justify-center rounded-[8px] bg-gray-10 hover:bg-gray-50 w-[60px]"
        onClick={handleClick}
      >
        <img
          src="/icons/info-coverage.svg"
          alt="Couverture"
          className="cursor-pointer"
          style={{ width: 34, height: 34, objectFit: "contain" }}
        />
      </button>
    );
  };

  const nameToLabel = (name) => {
    switch (name) {
      case "allergicRhinitis":
        return "Allergic Rhinitis";
      case "AnnualMedicationReview":
        return "Medication Review";
      default:
        return name;
    }
  };

  const deleteService = (type, serviceId) => {
    if (type === ClinicalServiceTypes.AllergicRhinitis) {
      dispatch(deleteClinicalService(id, serviceId, navigate));
    } else if (type === ClinicalServiceTypes.MedicationReview) {
      dispatch(deleteMedicationReview(id, serviceId, navigate));
    }
  };

  const navigateFromClinicalService = () => {
    // Block Patient Chart when any Minor Ailment service is running
    const hasRunningMinorAilment = minorAilments?.some(
      (svc) => svc.status === "inProgress"
    );
    const isCurrentMinorAilment = minorAilments?.some(
      (svc) => params.serviceId === svc.id
    );

    if (hasRunningMinorAilment || isCurrentMinorAilment) {
      return setOpenExitServiceDialog(true);
    }
    if (navigationItem) {
      navigateUser(navigationItem);
    }
  };

  const navigateVerify = (item) => {
    if (!item) return;
    
    if (item.name === "Patient Chart") {
      // If any Minor Ailment is running, block navigation (even if not on a service route)
      const hasRunningMinorAilment = minorAilments?.some(
        (svc) => svc.status === "inProgress"
      );
      if (params.serviceId || hasRunningMinorAilment) {
        setNavigationItem(item);
        return navigateFromClinicalService();
      }
    }
    navigateUser(item);
  };

  const navigateUser = (item) => {
    if (!item || !item.href) return;
    navigate(item.href);
    setSelectedTab(item.name);
  };

  useEffect(() => {
    let tab = null;
    // Check if the current URL matches one of the settings
    if (params.serviceId) {
      minorAilments?.map((item) => {
        if (params.serviceId === item.id) tab = item.minorAilmentTypeCode;
      });
      medicationReviews?.map((item) => {
        if (params.serviceId === item.id) tab = item.medicationReviewTypeCode;
      });
    } else {
      tabs.map((item) => {
        if (location.pathname === item.href) tab = item.name;
      });
    }

    setSelectedTab(tab ?? tabs[0].name);
  }, [location, medicationReviews, minorAilments]);

  const dynamicTabs = [];
  dynamicTabs.push(tabs[0]);
  dynamicTabs.push(tabs[1]);

  minorAilments
    ?.filter((x) => x.status === "inProgress")
    .forEach((item) => {
      dynamicTabs.push({
        ...item,
        name: nameToLabel(item?.minorAilmentTypeCode),
        type: "minorAilment",
      });
    });

  medicationReviews
    ?.filter((x) => x.status === "inProgress")
    .forEach((item) => {
      dynamicTabs.push({
        ...item,
        name: nameToLabel(item?.medicationReviewTypeCode),
        type: "medicationReview",
      });
    });

  dynamicTabs.push(tabs[2]);

  return (
    <div className="flex flex-1 w-full bg-gray-20">
      <div className="relative flex flex-col w-full gap-4 p-5 bg-white rounded">
        <div className="flex flex-col flex-1">
          <Tab.Group>
            <Tab.List>
              <div className="flex justify-between border-b-[4px] border-gray-100">
                <div className="flex gap-2 lg:text-lg text-body-md items-end">
                  {dynamicTabs.map((item, index) => {
                    const isMainTab =
                      item.type === undefined || item.type === "main";
                    const isClinicalServicesTab =
                      item.name === "Clinical Services";
                    const isMinorAilment = item.type === "minorAilment";
                    const isMedicationReview = item.type === "medicationReview";
                    const isServiceActive =
                      isMinorAilment || isMedicationReview;
                    const isActive = isMainTab
                      ? item.name === selectedTab
                      : params.serviceId === item.id;

                    const clinicalServiceIsActive =
                      minorAilments?.some(
                        (item) => params.serviceId === item.id
                      ) ||
                      medicationReviews?.some(
                        (item) => params.serviceId === item.id
                      );

                    return (
                      <Tab key={index} as={Fragment}>
                        {() => (
                          <button
                            className={`max-h-[52px] hover:bg-gray-100 min-w-[202px] transition-all rounded-t rounded-[4px] px-6 py-3 leading-none font-semibold flex items-center gap-3 !outline-none  mb-[-4px]
                            ${
                              isActive
                                ? "border-[4px] border-gray-100 border-b-white text-teal-300 relative z-10 bg-white"
                                : isClinicalServicesTab &&
                                  clinicalServiceIsActive
                                ? "border-[4px] border-gray-100 border-b-[4px] border-b-gray-100 text-teal-300"
                                : "border-[4px] border-transparent border-b-[4px] border-b-gray-100 text-gray-600"
                            }`}
                            onClick={(e) => {
                              // Don't navigate if clicking on the menu (3 dots)
                              if (e.target.closest('[data-menu-container]')) {
                                return;
                              }
                              if (isMainTab) {
                                navigateVerify(item);
                              } else {
                                navigate(
                                  `/patient/${id}/clinical-services/${item?.id}`
                                );
                                setSelectedTab(
                                  isMinorAilment
                                    ? item?.minorAilmentTypeCode
                                    : item?.medicationReviewTypeCode
                                );
                              }
                            }}
                          >
                            {isMainTab && (
                              <ReactSVG
                                src={isActive ? item?.icon : item?.iconInactive}
                                className={`w-6`}
                              />
                            )}
                            {isMinorAilment && (
                              <>
                                <ReactSVG
                                  src={
                                    isActive
                                      ? "/icons/rx-tabs.svg"
                                      : "/icons/rx-tabs-inactive.svg"
                                  }
                                  data-tooltip-id={"MATooltip"}
                                  className={`w-6 ${isActive ? "filter" : ""}`}
                                />
                                <NewToolTip
                                  id={"MATooltip"}
                                  render={() => (
                                    <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
                                      Minor Ailment Service
                                    </div>
                                  )}
                                />
                              </>
                            )}
                            {isMedicationReview && (
                              <>
                                <ReactSVG
                                  src={
                                    isActive
                                      ? "/icons/medication-review-tab.svg"
                                      : "/icons/medication-review-tab-inactive.svg"
                                  }
                                  className={`w-6 ${isActive ? "filter" : ""}`}
                                />
                              </>
                            )}

                            {item?.name}
                            {(item?.showOptions ||
                              isMinorAilment ||
                              isMedicationReview) && (
                              <div className="relative" data-menu-container>
                                <Menu>
                                  <Menu.Button 
                                    className="inline-flex justify-center w-full px-1 py-1 bg-white border border-white rounded-md hover:bg-gray-50 focus:outline-none"
                                  >
                                    <ReactSVG
                                      src={`/icons/vertical-dots-active.svg`}
                                      className={`flex justify-end items-end ml-1 w-5`}
                                    />
                                  </Menu.Button>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                  >
                                    <Menu.Items className="absolute right-0 top-full mt-2 w-38 bg-white border border-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none !z-50">
                                    <div className="h-px bg-gray-50"></div>
                                    <Menu.Item>
                                      {({ active }) => (
                                        <div
                                          className={`${
                                            active ? "bg-gray-50 " : ""
                                          } cursor-pointer`}
                                        >
                                          <button
                                            className="m-3 text-body-md whitespace-nowrap"
                                            onClick={() => {
                                              if (isMinorAilment) {
                                                setOpenDeleteService(true);
                                              } else {
                                                setOpenDeleteServiceForMedical(
                                                  true
                                                );
                                              }
                                              setDeleteServiceId(item.id);
                                            }}
                                          >
                                            Cancel Service
                                          </button>
                                        </div>
                                      )}
                                    </Menu.Item>
                                  </Menu.Items>
                                </Transition>
                                </Menu>
                              </div>
                            )}
                          </button>
                        )}
                      </Tab>
                    );
                  })}
                </div>
                {selectedTab !== "Clinical Services" && (
                  <PatientQuickActions
                    hasSavedNotes={hasSavedNotes}
                    openNotePad={openNotePad}
                    onToggleNotePad={handleToggleNotePad}
                    rxVigilanceAuthUrl={rxVigilanceAuthUrl}
                    rxVigilanceBaseUrl={rxVigilanceBaseUrl}
                  />
                )}
              </div>
            </Tab.List>
            <Tab.Panels className={"flex flex-1 w-full"}>{children}</Tab.Panels>
          </Tab.Group>
        </div>
      </div>
      <NotePadModal
        open={openNotePad}
        serviceName={clinicalServiceName}
        onCross={() => setOpenNotePad(false)}
        handleClose={() => setOpenNotePad(false)}
        confirmAction={() => {
          setOpenNotePad(false);
        }}
      />
      <ConfirmationModalNew
        open={openSaveService}
        title={"Save & Pause Service"}
        className="!w-[800px] !max-w-xl"
        content={() => (
          <p className="p-6 text-left text-gray-600 text-body-md">
            Selecting Save & Pause will allow navigation to a new Clinical
            Service; then return back to the current module.
          </p>
        )}
        type={"primary"}
        confirmText={"Continue"}
        cancelText={"Cancel"}
        handleClose={() => setOpenSaveService(false)}
        onCross={() => setOpenSaveService(false)}
        confirmAction={() => setOpenSaveService(false)}
      />
      <ConfirmationModalNew
        open={openDeleteService}
        title={"Cancel Minor Ailment"}
        className="!w-[630px] !max-w-2xl"
        content={() => (
          <div className="">
            <p className="text-left text-gray-800 text-body-md">
              By selecting <span className="font-semibold text-teal-300">Cancel</span>, you
              will return to the{" "}
              <span className="font-semibold text-teal-300">Clinical Services</span> homepage
              to select a different option.
            </p>
            <br />
            <p className="text-left text-gray-800 text-body-md">
              The current assessment will be discarded if you choose a new
              clinical service.
            </p>
          </div>
        )}
        type={"primary"}
        confirmText={"Cancel Service"}
        cancelText={"Continue"}
        verticalButtons={false}
        handleClose={() => {
          setOpenDeleteService(false);
        }}
        onCross={() => setOpenDeleteService(false)}
        confirmAction={() => {
          setOpenDeleteService(false);
          deleteService(ClinicalServiceTypes.AllergicRhinitis, deleteServiceId);
        }}
      />
      <ConfirmationModalNew
        open={openSaveServiceForMedical}
        title={"Save & Pause Service"}
        className="!w-[800px] !max-w-xl"
        content={() => (
          <p className="p-6 text-left text-gray-600 text-body-md">
            Selecting Save & Pause will allow navigation to a new Clinical
            Service; then return back to the current module.
          </p>
        )}
        type={"primary"}
        confirmText={"Continue"}
        cancelText={"Cancel"}
        handleClose={() => setOpenSaveServiceForMedical(false)}
        onCross={() => setOpenSaveServiceForMedical(false)}
        confirmAction={() => setOpenSaveServiceForMedical(false)}
      />
      <ConfirmationModalNew
        open={openDeleteServiceForMedical}
        title={"Cancel Medication Review"}
        className="!w-[630px] !max-w-2xl"
        content={() => (
          <div className="">
            <p className="text-left text-gray-800 text-body-md">
              By selecting <span className="font-semibold text-teal-300">Cancel</span>, you
              will return to the{" "}
              <span className="font-semibold text-teal-300">Clinical Services</span> homepage
              to select a different option.
            </p>
            <br />
            <p className="text-left text-gray-800 text-body-md">
              The current assessment will be discarded if you choose a new
              clinical service.
            </p>
          </div>
        )}
        type={"primary"}
        confirmText={"Cancel Service"}
        cancelText={"Continue"}
        verticalButtons={false}
        handleClose={() => {
          setOpenDeleteServiceForMedical(false);
        }}
        onCross={() => setOpenDeleteServiceForMedical(false)}
        confirmAction={() => {
          setOpenDeleteServiceForMedical(false);
          deleteService(ClinicalServiceTypes.MedicationReview, deleteServiceId);
        }}
      />
      <ChartUpdatesDialog
        open={openExitServiceDialog}
        title="Chart Updates During Minor Ailment Services"
        titleClassName="!text-[24px]"
        onClose={() => setOpenExitServiceDialog(false)}
        onConfirm={() => {
          setOpenExitServiceDialog(false);
          if (serviceId) {
            navigate(`/patient/${id}/clinical-services/${serviceId}`);
          } else {
            // Find the running Minor Ailment service
            const runningService = minorAilments?.find(
              (svc) => svc.status === "inProgress"
            );
            if (runningService) {
              navigate(`/patient/${id}/clinical-services/${runningService.id}`);
            }
          }
        }}
      />
    </div>
  );
};

export default PatientLayoutMain;
